import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Anchor, Button } from '@costar/theme-ui';

var defaultExpandAnchorProps = {
  target: '_blank'
};
var isAnchor = function isAnchor(props) {
  return !!props.href;
};
var Expand = function Expand(props) {
  if (isAnchor(props)) {
    return /*#__PURE__*/React.createElement(Anchor, _extends({}, defaultExpandAnchorProps, props));
  } else {
    return /*#__PURE__*/React.createElement(Button, props);
  }
};

export { Expand };
//# sourceMappingURL=expand.esm.js.map
